import React from "react";
import { Routes, Route } from "react-router-dom";
import ContactDetail from "./contact-detail";

//
const ContactUs = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="" element={<ContactDetail />} />
         <Route path="/" element={<ContactDetail />} />
      </Routes>
    </React.Fragment>
  );
};

export default ContactUs;
